// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".monitor-stats{display:flex;flex-direction:row;justify-content:space-evenly}.monitor-stats h3{font-size:25px;color:#999999}.monitor-stats h1{margin-top:0px !important;color:#027aff}.monitor-stats .loader-parent{position:relative}.monitor-stats .content-box{flex-grow:1;margin:10px}.monitor-stats .table-parent{max-height:250px;overflow:auto}.monitor-stats table{border:1px solid #d3d3e9}\n", ""]);
// Exports
module.exports = exports;
